import React from 'react';
import { Link } from 'react-router-dom';
import { useServices } from '../../../hooks/useServices';
import { useSettings } from '../../../hooks/useSettings';
import './Footer.css';
import logo from '../../../assets/images/Logo.webp';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { services } = useServices();
  const { settings } = useSettings();

  const getShortName = (name) => {
    if (name.includes('Intuitive Reiki — Tune')) return 'Reiki - Tune & Restore';
    if (name.includes('Intuitive Reiki — Intro')) return 'Reiki - Intro & Integrate';
    if (name.includes('Deep Release')) return 'Deep Release & Rebalance';
    if (name.includes('Tarot')) return 'Tarot Readings';
    if (name.includes('Soul Alignment')) return 'Soul Alignment Coaching';
    if (name.includes('Chakra')) return 'Chakra Healing';
    if (name.includes('Space')) return 'Space Clearing';
    if (name.includes('Restorative')) return 'Restorative Reiki Classes';
    if (name.includes('Guided Ascension')) return 'Guided Ascension Program';
    return name;
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__main">
          <div className="footer__section footer__about">
            <img src={logo} alt={settings?.businessName || 'KO Holistic Health and Wellbeing'} className="footer__logo" />
            <p className="footer__tagline">
              {settings?.footerTagline || 'Enhancing lives through holistic healing and spiritual guidance'}
            </p>
            <div className="footer__social">
              {settings?.instagram && (
                <a href={settings.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
              )}
              {settings?.facebook && (
                <a href={settings.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
              )}
              {settings?.linkedin && (
                <a href={settings.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                </a>
              )}
              {settings?.youtube && (
                <a href={settings.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
                  </svg>
                </a>
              )}
            </div>
          </div>

          <div className="footer__section">
            <h4 className="footer__title">Quick Links</h4>
            <ul className="footer__links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/speaker">Speaker</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/gift-card">Gift Cards</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer__section">
            <h4 className="footer__title">Services</h4>
            <ul className="footer__links">
              {services.slice(0, 8).map((service) => (
                <li key={service.id}>
                  <Link to={`/services/${service.slug}`}>{getShortName(service.name)}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__section">
            <h4 className="footer__title">Contact</h4>
            <ul className="footer__links footer__contact">
              <li>
                <a href={`tel:${settings?.phoneFormatted || '+61439386551'}`}>
                  {settings?.phone || '0439 386 551'}
                </a>
              </li>
              <li>{settings?.city || 'Sydney'}, {settings?.state || 'NSW'}</li>
              <li>{settings?.country || 'Australia'}</li>
              <li>
                <a href={`mailto:${settings?.email || 'info@koholistichealth.com'}`}>
                  {settings?.email || 'info@koholistichealth.com'}
                </a>
              </li>
            </ul>
            <div className="footer__credentials">
              <p><strong>Credentials:</strong></p>
              <ul>
                {settings?.credentials?.map((credential, index) => (
                  <li key={index}>{credential}</li>
                )) || (
                  <>
                    <li>Reiki Master Teacher</li>
                    <li>Restorative Yin Instructor</li>
                    <li>Meditation Teacher</li>
                    <li>Soul Coaching Practitioner</li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {currentYear} {settings?.footerCopyright || 'KO Holistic Health and Wellbeing. All rights reserved.'}</p>
          <p className="footer__credit">
            {settings?.ownerName || 'Kirstie Warburton'} | {settings?.ownerTitle || 'Holistic Health Practitioner'}
          </p>
          <p className="footer__bug-link">
            <Link to="/report-bug">Report a bug</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
